/**
 * Jazz binding for the `CurrentUser` shape: projects the loaded account down
 * to an id and a display name. Components go through
 * `hooks/useCurrentUser` rather than importing this directly, so the backend
 * choice lives in one place.
 */
import { useMemo } from "react";
import { useAccount } from "jazz-tools/react";
import { VibeDiagramAccount } from "./schema";
import type { CurrentUser } from "../stores/CurrentUser";

/** Null while the account is still being set up. */
export function useJazzCurrentUser(): CurrentUser | null {
  const { me } = useAccount(VibeDiagramAccount);
  const id = me?.$jazz.id;
  const name = me?.profile?.name;

  return useMemo(() => (id === undefined ? null : { id, name }), [id, name]);
}
